module.exports = __webpack_public_path__ + "img/woman_fairy.b9b4621f.gif";